export default __webpack_public_path__ + "static/media/unauth-face.d79e5061.svg";